export const noName="zzzzzzzzzzzzzzzzz";


export const CART_SORT_BY = {
    ITEM: 1,
    ITEMGROUP: 2,
    ITEMCATALOGUE:3,
    LEGACYCODE:4
}

export const LANGUAGES =[
    {id:1, name:'en'},
    {id:2, name:'gb'},
    {id:3, name:'pl'},
    {id:4, name:'es'},
    {id:5, name:'fr'},
    {id:6, name:'de'},
    {id:7, name:'no'}
]

  
export const LANGUAGE_OBJ ={
    en: 'en',
    gb:'gb',
    pl:'pl',
    es:'es',
    fr:'fr',
    de:'de',
    no:'no'
}
  

export const ERROR_TYPE ={
    NetworkError:'Network Error'
}

